<template>
  <div class="contents-box">
    <div class="contents">
      <p class="contents-title">您的MOVIBOT账户{{ statustext }}</p>
      <router-link class="contents-a" :to="{ name: 'login' }"
        >登录账号</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statustext: "待激活",
    };
  },
  metaInfo() {
    return {
      title: "欢迎登录Movibot官网",
      meta: [
        { name: "keywords", content: "Movibot官网" },
        { name: "description", content: "欢迎登录Movibot网站" },
      ],
    };
  },
  methods: {
    activityUser() {
      this.$api.user.activityUser(this.$route.params.code).then((res) => {
        if (res.data.errno == 0) {
          this.statustext = "已激活";
        }
      });
    },
  },
  mounted() {
    this.activityUser();
  },
};
</script>

<style scoped>
.contents-box {
  background-color: #f3f5f7;
  overflow: hidden;
  min-height: 900px;
}
.contents-title {
  font-size: 36px;
  line-height: 36px;
  color: #666666;
  margin-top: 30px;
  margin-bottom: 37px;
}
.contents-a {
  font-size: 24px;
  line-height: 26px;
  color: #2655ae;
}
</style>


// WEBPACK FOOTER //
// src/views/user/activate.vue